module.exports = __webpack_public_path__ + "static/cercazone_nordovest4-61f0c521fe5c7d67101586b9bfd3efd2.jpg";